import { isValidPhoneNumber, parsePhoneNumberFromString } from 'libphonenumber-js';
import type { CountryCode } from 'libphonenumber-js';

export function getCountryFromPhoneNumber(phone: string): CountryCode | undefined {
  const trimmed = phone?.trim() ?? '';
  if (!trimmed) return undefined;

  const parsed = parsePhoneNumberFromString(trimmed);
  if (parsed?.country) {
    return parsed.country;
  }

  return undefined;
}

const COUNTRY_NAME_TO_ISO: Record<string, CountryCode> = {
  'United States': 'US',
  'United Kingdom': 'GB',
  Canada: 'CA',
  Australia: 'AU',
  Germany: 'DE',
  France: 'FR',
  Ukraine: 'UA',
  Italy: 'IT',
  Spain: 'ES',
  Netherlands: 'NL',
  Poland: 'PL',
  Belgium: 'BE',
  Austria: 'AT',
  Switzerland: 'CH',
  Sweden: 'SE',
  Norway: 'NO',
  Denmark: 'DK',
  Finland: 'FI',
  Ireland: 'IE',
  Portugal: 'PT',
  Greece: 'GR',
  'Czech Republic': 'CZ',
  Romania: 'RO',
  Hungary: 'HU',
  Japan: 'JP',
  'South Korea': 'KR',
  China: 'CN',
  India: 'IN',
  Brazil: 'BR',
  Mexico: 'MX',
  Argentina: 'AR',
  'New Zealand': 'NZ',
  Singapore: 'SG',
  Israel: 'IL',
  'United Arab Emirates': 'AE',
  Turkey: 'TR',
};

export function validatePhoneNumber(phone: string, countryName?: string): boolean {
  const trimmed = phone?.trim() ?? '';
  if (!trimmed) return false;

  if (isValidPhoneNumber(trimmed)) {
    return true;
  }

  const iso = countryName ? COUNTRY_NAME_TO_ISO[countryName] : undefined;
  if (iso) {
    if (isValidPhoneNumber(trimmed, iso)) {
      return true;
    }
    const parsed = parsePhoneNumberFromString(trimmed, iso);
    if (parsed?.isValid()) {
      return true;
    }
  }

  const international = parsePhoneNumberFromString(trimmed);
  if (international?.isValid()) {
    return true;
  }

  return false;
}
